import { ITheme } from '../interfaces/styled';
import { breakpoints } from '@config';

const pcTheme: ITheme = {
  family: 'SuisseIntl, sans-serif',
  fontSize: {
    xxl: 48,
    xl: 48,
    lg: 40,
    md: 24,
    sm: 20,
    xs: 16
  },
  maxWidth: 1200,
  colors: {
    bg: '#000000',
    bgLittleTransparency: 'rgba(0, 0, 0, 0.8)',
    bgMoreTransparency: 'rgba(0, 0, 0, 0.6)',
    text: '#FFFFFF',
    textLittleTransparency: 'rgba(255, 255, 255, 0.8)',
    textMoreTransparency: 'rgba(255, 255, 255, 0.6)'
  },
  queries: {
    pc: `min-width: ${breakpoints.pc}`
  }
};

const mobileTheme: ITheme = {
  ...pcTheme,
  fontSize: {
    xxl: 40,
    xl: 36,
    lg: 32,
    md: 20,
    sm: 20,
    xs: 16
  }
};

export { pcTheme, mobileTheme };
